import $ from '/js/header/jquery.js';
import { DaySchedule } from '/js/header/DaySchedule';
import { LoginManager } from "/js/header/auth/LoginManager";
import { ViewModeHelper } from '/js/tools/ViewModeHelper';

export class Header {
    constructor() {
        this.loginManager = new LoginManager();
        this.daySchedule = new DaySchedule();
        this.viewModeHelper = new ViewModeHelper();
    }

    caNoSrch() {
        if (parseInt($("#num2_Top").val()) > 0) {
            location.href = "/ca/caList.php?mainLink=custom&sn1=" + $("#num1_Top").val() + "&sn2=" + $("#num2_Top").val();
        } else {
            alert("사건번호를 입력 해 주세요~");
        }
    }

    supports_local_storage() {
        return (typeof window.localStorage != 'undefined');
    }
}

export const header = new Header();

// 즉시 실행 (async 밖으로 이동)
$(() => {
    // 강제 PC버전 보기 이벤트리스너 설정
    header.viewModeHelper.setForceDesktopButtonListener();
    // width값이 1200이하일때 .snb_menuW > li > a 중 .on인 요소로 가로 스크롤 이동
    if ($(window).width() <= 1200) {
        // 전체메뉴는 이거
        let gnbMenuOn = $('.gnb > li > a.on');
        if (gnbMenuOn.length > 0) {
            let gnbMenuOnOffset = gnbMenuOn.offset().left;
            // 스크롤 부드럽게
            $('.header_center').animate({ scrollLeft: gnbMenuOnOffset - 20 }, 300);
        }

        // 검색페이지 snbW일때는 이거
        let snbMenuOn = $('.snb_menuW > li > a.on');
        if (snbMenuOn.length > 0) {
            let snbMenuOnOffset = snbMenuOn.offset().left;
            // 스크롤 부드럽게
            $('.snb_menuW').animate({ scrollLeft: snbMenuOnOffset - 50 }, 300);
        }

        // 게시판, 자료실등 snb일때는 이거
        let snbOn = $('.snb_menu > li > a.on');
        if (snbOn.length > 0) {
            let snbOnOffset = snbOn.offset().left;
            // 스크롤 부드럽게
            $('.snb_menu').animate({ scrollLeft: snbOnOffset - 20 }, 300);
        }
    }

    // fmSrchTop 제출이벤트
    $('#fmSrchTop').on('submit', function (e) {
        e.preventDefault();
        header.caNoSrch();  // ✅ 동기 메서드는 바로 사용
    });

    //맨 위로 이동
    $('#movetop').bind('click', function () {
        $('html,body').animate({
            scrollTop: '0'
        }, 100);
    });
    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if (scroll >= 150) {
            $("#movetop").fadeIn(100);
        } else {
            $("#movetop").fadeOut(200);
        }
    });
});